import { render } from "@/components/pages/individualWorkSupport/requirement049/Requirement049.html?vue&type=template&id=a20e0538&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement049/Requirement049.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement049/Requirement049.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement049/Requirement049.scss?vue&type=style&index=0&id=a20e0538&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20e0538"]])

export default __exports__